import React from 'react';
import { IconPin, IconPhone, IconClock, IconMail, IconNavigate } from '../components/Icons';

const ContactsPage = () => {
  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Контактная информация</h1>
        <p>Ждем вас в нашем сервисе в Бийске. Звоните, проконсультируем по всем вопросам!</p>
      </div>

      <div className="contact-grid">
        
        {/* Левая колонка с контактами */}
        <div className="contact-card-list">
          
          {/* Адрес */}
          <div className="contact-item">
            <div className="contact-icon-box">
              <IconPin size={22} color="#a80000" />
            </div>
            <div className="contact-info-text">
              <span className="contact-label">Адрес сервиса</span>
              <strong className="contact-value">г. Бийск, ул. Революции, 55а</strong>
              <span className="contact-hint">Удобный заезд с улицы Барнаульский взвоз</span>
            </div>
          </div>

          {/* Телефон */}
          <div className="contact-item">
            <div className="contact-icon-box">
              <IconPhone size={20} color="#a80000" />
            </div>
            <div className="contact-info-text">
              <span className="contact-label">Телефон для записи</span>
              <a href="tel:+79609474777" className="contact-phone-link">+7 (960) 947-47-77</a>
              <span className="contact-hint">Отвечаем в рабочие часы, консультация бесплатная</span>
            </div>
          </div>

          {/* График работы */}
          <div className="contact-item">
            <div className="contact-icon-box">
              <IconClock size={20} color="#555" />
            </div>
            <div className="contact-info-text">
              <span className="contact-label">Режим работы</span>
              <strong className="contact-value">Ежедневно: 09:00 — 20:00</strong>
              <span className="contact-badge-open">Без выходных и перерывов</span>
            </div>
          </div>

          {/* Email */}
          <div className="contact-item">
            <div className="contact-icon-box">
              <IconMail size={20} color="#555" />
            </div>
            <div className="contact-info-text">
              <span className="contact-label">Электронная почта</span>
              <a href="mailto:ag1309@mail.ru" className="contact-email-link">ag1309@mail.ru</a>
            </div>
          </div>

          {/* Кнопки действий */}
          <div className="contact-actions">
            <a href="tel:+79609474777" className="btn-primary cta-button">
              <IconPhone size={18} color="#000" />
              <span>Позвонить</span>
            </a>
            <a 
              href="https://yandex.ru/maps/org/avtosteklo_servis/165795693107/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-secondary cta-button"
            >
              <IconNavigate size={18} color="#333" />
              <span>Проложить маршрут</span>
            </a>
          </div>

        </div>

        {/* Правая колонка: Карта */}
        <div className="map-wrapper">
          <iframe 
            src="https://yandex.ru/map-widget/v1/org/avtosteklo_servis/165795693107/?ll=85.224716%2C52.551757&z=16"
            width="100%"
            height="100%" 
            frameBorder="0"
            title="Автостекло-Сервис на карте Бийска"
            allowFullScreen={true}
          ></iframe>
        </div>

      </div>
    </div>
  );
};

export default ContactsPage;